/**
 * utils.js
 * Created by calhosh on 11/6/2019.
 */
import { resources } from "../resources/resources";
import { dateTimeFormats } from "./UIConstants";
import moment from "moment";
// let lang = env.getLanguage();
// export let currentResource = resources(lang);
export let currentResource = resources("en-us");
export let labels = currentResource.labels;

/*set user selected language*/
export const setLanguage = (language) => {
  if (language) {
    currentResource = resources(language);
    labels = currentResource.labels;
  }
};

/**
 * Return number formatted data
 * @param {Number} userPreferenceNumberFormat - number format.
 * @param {string} freeText - freeText.
 *  @returns {string} return number formatted value
 **/
export const numberFormattedText = (userPreferenceNumberFormat, freeText) => {
  if (freeText !== null && freeText.length > 0) {
    switch (userPreferenceNumberFormat) {
      case 0:
        return freeText.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      case 1:
        let numberText = String(freeText),
          subText = "",
          appendNumber = "";
        if (numberText.length > 3) {
          subText = numberText.substring(0, numberText.length - 3);
          appendNumber = "," + numberText.substring(numberText.length - 3, numberText.length);
        } else {
          subText = numberText;
        }
        return subText.toString().replace(/(\d)(?=(\d{2})+(?!\d))/g, "$1,") + appendNumber;
      case 2:
        return freeText !== undefined && freeText !== null
          ? freeText.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ")
          : "";
      case 3:
        return freeText !== undefined && freeText !== null
          ? freeText.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")
          : "";
    }
  } else {
    return " ";
  }
};

export const debounce = (func, wait) => {
  let firstInvocation = true;
  console.log("DEBOUNCED", firstInvocation);
  return (...args) => {
    if (firstInvocation) {
      // window.clearTimeout(timeoutId);
      func.apply(null, args);
      firstInvocation = false;
      window.setTimeout(() => {
        firstInvocation = true;
      }, wait);
    }
  };
};

export const getFormattedDate = (date,userFormat) => {
  let dateObj = new Date(date);
  const formattedDate = moment(dateObj).format(dateTimeFormats[userFormat].label);
  return formattedDate;
}

//Convert Excel String Date to GerGorian
export const excelSerialDateToReadableDate=(serialDate,userFormat)=>{
  // Excel's serial date starts from January 1, 1900
  const excelDate = new Date(1899, 11, 30);
  const jsDate = new Date(excelDate.getTime() + serialDate * 86400000);
  const formattedDate = getFormattedDate(jsDate,userFormat);
  return formattedDate
}


export const getDateListinReadableFormat=(dateList,userFormat)=>{

  return dateList.map(date=>{
    return excelSerialDateToReadableDate(date,userFormat)
  });

}


export const isNullOrWhitespace = (input) => {
	return !input || !input.trim();
};

export function isNullOrUndefined(value) {
	return value === null || value === undefined;
}
